<mat-card class="ft-component-error" appearance="outlined">
    <mat-card-content>
        <mat-icon>error</mat-icon>
        @if (componentDefinition.errorMessage) {
            <span class="ft-component-error__message">{{componentDefinition.errorMessage}}</span>
        }
    </mat-card-content>
</mat-card>
